
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface HistorialOrden {
  id: number;
  orden_mantenimiento_id: number;
  estado_anterior_id?: number | null;
  estado_nuevo_id?: number | null;
  observacion?: string | null;
  usuario_id?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface RespuestaHistorialOrden {
  codigo: number;
  mensaje: string;
  data: HistorialOrden[];
}

@Injectable({
  providedIn: 'root'
})
export class HistorialOrdenService {

  private readonly apiUrl =
    `${environment.apiUrl}/api/historial-ordenes-mantenimiento`;

  constructor(private http: HttpClient) {}

  /**
   * Consultar el historial de una orden específica.
   */
  obtenerPorOrden(
    ordenId: number
  ): Observable<RespuestaHistorialOrden> {
    return this.http.get<RespuestaHistorialOrden>(
      `${this.apiUrl}/orden/${ordenId}`, { withCredentials: true }
      
    );
  }

  /**
   * Consultar todo el historial.
   */
  obtenerTodos(): Observable<RespuestaHistorialOrden> {
    return this.http.get<RespuestaHistorialOrden>(
      this.apiUrl, { withCredentials: true }
    );
  }
}
